@if (passFound && !loading) {
  <div slot="content">
    <ix-layout-grid class="h-100 w-100 position-relative" columns="12">
      <ix-row>
        <ix-col>
          <ix-breadcrumb>
            <ix-breadcrumb-item
              (itemClick)="navigateToPassportList()"
              [label]="'dpp.general.passport_overview' | translate"
              icon="project"
            ></ix-breadcrumb-item>
            <ix-breadcrumb-item
              (itemClick)="navigateToPassportDetail()"
              [label]="shellName || dppId"
            ></ix-breadcrumb-item>
            <ix-breadcrumb-item [label]="submodelName"></ix-breadcrumb-item>
          </ix-breadcrumb>
        </ix-col>
      </ix-row>
      <ix-row>
        <ix-col>
          <ix-content-header
            id="genericSubmodelViewerHeader"
            [hasBackButton]="true"
            (backButtonClick)="onBackButtonClick()"
            [headerTitle]="submodelName"
          >
            <ix-pill slot="header" class="margin-top">{{
              submodelVersion ? 'v' + submodelVersion : undefined
            }}</ix-pill>
            <!-- Edit button -->
            @if (!WindowSizeService.windowSizeSmall()) {
              <ix-button
                class="me-2"
                icon="pen"
                id="editGenericSubmodelButton"
                variant="secondary"
                (click)="navigateToGenericEditor()"
                onkeydown=""
              >
                {{ 'battery_pass.private.edit' | translate }}
              </ix-button>
            }
            @if (WindowSizeService.windowSizeSmall()) {
              <ix-icon-button
                class="me-2"
                icon="pen"
                id="editGenericSubmodelButtonSmallScreen"
                variant="secondary"
                (click)="navigateToGenericEditor()"
                onkeydown=""
              ></ix-icon-button>
            }
          </ix-content-header>
        </ix-col>
      </ix-row>
      <div class="key-value-list-wrapper">
        <ix-key-value-list>
          @for (
            element of submodel?.submodelElements ?? [];
            track element.idShort
          ) {
            <app-dpp-submodel-field [element]="element" />
          }
        </ix-key-value-list>
      </div>

      </ix-layout-grid>
  </div>
}

@if (loading) {
  <div class="d-flex justify-content-center">
    <ix-spinner size="large" class="mt-5"></ix-spinner>
  </div>
}

@if (!passFound) {
  <div class="d-flex justify-content-center">
    <ix-empty-state
      class="mt-5"
      header="{{ 'battery_pass.list.no_passport_available' | translate }}"
      subHeader="{{ 'battery_pass.private.no_pass_sub_header' | translate }}"
      icon="error"
      action="{{ 'battery_pass.public.action' | translate }}"
    ></ix-empty-state>
  </div>
}
